import React from 'react';

import { type App } from 'generated/graphql';

import Image from 'components/Image/Image';

import IconInfoFilled from 'icons/ic_ErrorInfoFilled.svg';
import styles from './AppErrorList.module.scss';

type Props = {
  apps: App[];
};

const AppErrorList: React.FC<Props> = ({ apps }) => {
  return (
    <ul className={styles.Outer}>
      {apps.map((app: App) => {
        return (
          <li data-testid="app-error-list-item" key={app.id} className={styles.Item}>
            <Image testId="app-error-list-item-image" alt={app.name} src={app.image || ''} className={styles.Image} />
            <span>{app.name}</span>
            <span>
              <img src={IconInfoFilled} alt="" />
              Failed to update
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default AppErrorList;
